import { P2GBox } from '@parcel2go/core-ui';
import { ReactNode } from 'react';

interface props {
  left: ReactNode;
  right: ReactNode;
  width: number;
  alignment?: 'left' | 'right';
  spacing?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
  alignContent?: 'stretch' | 'center' | 'flex-start' | 'flex-end' | 'space-between' | 'space-around';
  alignItems?: 'flex-start' | 'center' | 'flex-end' | 'stretch' | 'baseline';
}

const FixedColumn: React.FC<props> = (props) => (
  <P2GBox
    sx={{
      display: 'flex',
      flexWrap: 'nowrap',
      alignContent: props.alignContent,
      gap: props.spacing,
      alignItems: props.alignItems
    }}
  >
    {props.alignment === 'right' ? (
      <>
        {props.left && (
          <P2GBox flexGrow={1} zeroMinWidth>
            <div>{props.left}</div>
          </P2GBox>
        )}
        <P2GBox flexShrink={1}>
          <P2GBox sx={{ width: props.width }}>{props.right}</P2GBox>
        </P2GBox>
      </>
    ) : (
      <>
        {props.left && (
          <P2GBox flexShrink={1}>
            <P2GBox sx={{ width: props.width, overflow: 'hidden' }}>{props.left}</P2GBox>
          </P2GBox>
        )}
        <P2GBox flexGrow={1} zeroMinWidth>
          {props.right}
        </P2GBox>
      </>
    )}
  </P2GBox>
);

export { FixedColumn };
